import * as ActionType from '../ActionType';

const initialState = {
  LOAD_CAMPAIGN_TAP_SURVEY: {
    loading: true,
    error: '',
  },
  LOAD_CAMPAIGN_TAP_SURVEY_RESULTS: {
    loading: true,
    error: '',
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ActionType.LOAD_CAMPAIGN_TAP_SURVEY_SUCCESS: {
      return {
        ...state,
        LOAD_CAMPAIGN_TAP_SURVEY: {
          loading: false,
          error: '',
        },
      };
    }
    case ActionType.LOAD_CAMPAIGN_TAP_SURVEY_REQUEST: {
      return {
        ...state,
        LOAD_CAMPAIGN_TAP_SURVEY: {
          loading: true,
          error: '',
        },
      };
    }
    case ActionType.LOAD_CAMPAIGN_TAP_SURVEY_FAILURE: {
      const { error } = action.payload;
      return {
        ...state,
        LOAD_CAMPAIGN_TAP_SURVEY: {
          loading: false,
          error: error,
        },
      };
    }
    default:
      return state;
  }
}
